import { defineVuePlugin } from '#/vue-plugins'

import { createAppI18n } from '@/i18n'

import { getAppConfig } from '@/shared/lib/tenant'

export default defineVuePlugin(async (app) => {
  const config = getAppConfig(app)
  const i18n = createAppI18n(config.locales, config.defaultLocale)
  app.use(i18n)
})
